import { createFileRoute } from '@tanstack/react-router';

import { ReferralsPage } from '@/app/referrals/referrals-page';

export const Route = createFileRoute('/referrals')({
  component: ReferralsPage,
});
